import { ScoreType } from '../../../../../../store/admin/eventFormats/store';
import { IMetaFormat } from '../../../../../../store/admin/roundFormats/store';

import { IStateDispatchActions } from '../ContestSetup.context';

export type ISelectFormat = (scoreType: ScoreType, metaFormat: IMetaFormat) => void;

export const selectFormat: IStateDispatchActions<ISelectFormat> = (_, dispatch) => (
  scoreType,
  metaFormat
) => {
  dispatch({ type: 'selectFormat', value: { scoreType, metaFormat } });
};
